import { HTMLAttributes } from 'react';
import { cn } from '~/lib/cn';

interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
    /** Pill shape for text lines (default); set false for blocks and squares. */
    rounded?: boolean;
}

// Pulsing placeholder that holds a real element's space while data loads, so nothing shifts on arrival.
export default function Skeleton({ className, rounded = true, ...props }: SkeletonProps) {
    return (
        <div
            aria-hidden
            className={cn('tw-animate-pulse tw-bg-accents-1', rounded ? 'tw-rounded-full' : 'tw-rounded-lg', className)}
            {...props}
        />
    );
}
